import useAuthContext from 'app/providers/AuthProvider';
import { permissionService, Permissions } from 'shared/services/permission.service';

export const usePermission = () => {
  const { profile } = useAuthContext();

  return {
    hasPermission: (permission: Permissions) => permissionService.hasPermission(profile?.Role || null, permission),

    hasAnyPermission: (permissions: Permissions[]) =>
      permissionService.hasAnyPermission(profile?.Role || null, permissions),

    hasAllPermissions: (permissions: Permissions[]) =>
      permissionService.hasAllPermissions(profile?.Role || null, permissions),
  };
};
